import jumbotron from "./jumbotron";

export default {
    jumbotron,
};
